module.exports = "/app/user/img/SILVER.8dfb676b.png";